import styles from './AirDnaBars.module.scss'

const BARS = [
  { height: '25%', hideMobile: true },
  { height: '65%', hideMobile: false },
  { height: '78%', hideMobile: true },
  { height: '62%', hideMobile: false },
  { height: '72%', hideMobile: false },
  { height: '66%', hideMobile: true },
  { height: '55%', hideMobile: false },
  { height: '45%', hideMobile: true },
  { height: '85%', hideMobile: false },
  { height: '40%', hideMobile: true },
  { height: '63%', hideMobile: false },
  { height: '70%', hideMobile: true },
  { height: '35%', hideMobile: false }
]

export const AirDnaBars = () => {
  return (
    <div className={styles.loadingContainer}>
      <ul className={styles.loadingChart}>
        {BARS.map(bar => (
          <li key={bar.height} className={bar.hideMobile ? styles.hidemobile : null}>
            <span style={{ height: bar.height }} title='' />
          </li>
        ))}
      </ul>
    </div>
  )
}
